import script from "./CurrentAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentAssets.vue?vue&type=script&setup=true&lang=js"

import "./CurrentAssets.vue?vue&type=style&index=0&id=f366e326&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f366e326"]])

export default __exports__